// 정식 등급이 되는 순간(시작 등급 지정 · 루키 승급 심사 승인) 가입비 결제 + 카드 등록 전 잠금 상태 (대표 지시 2026-10-20)
// 판정은 서버 tier_grant_payment_gate(p_email) 한 곳. 🔒 대상 이메일을 꼭 넘긴다 — 안 넘기면 서버가 로그인 계정을 보므로
//   어드민이 다른 회원으로 보고 있을 때 어드민 본인 상태가 그 회원 화면에 뜬다(CLAUDE.md 「fetchOverview(email)」 규칙과 같은 이유).
// 잠기지 않은 회원: 레이아웃이 처음 뜰 때 한 번만 부른다(작품 목록은 잠긴 사람에게만 온다).
// 잠긴 회원: 경로가 바뀔 때마다 다시 부른다 — 결제·카드 등록 뒤 다른 화면으로 가면 바로 풀린다.
// RPC 가 아직 없거나(마이그레이션 적용 전) 실패하면 잠그지 않는다 — 조회 실패로 회원을 막지 않는다.
// loaded = 첫 응답을 받았는지(시작하기 페이지가 「불러오는 중」과 「잠기지 않음 → 홈」을 가른다).
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";
import { normalizeGate } from "../lib/tierGrantGate";

export default function useTierGrantGate(email) {
  const { pathname } = useLocation();
  const [gate, setGate] = useState({ gated: false });
  const [loaded, setLoaded] = useState(false);
  const gatedRef = useRef(false);
  const seqRef = useRef(0);

  const load = useCallback(async () => {
    const seq = ++seqRef.current;
    if (!email) {
      gatedRef.current = false;
      setGate({ gated: false });
      setLoaded(true);
      return;
    }
    let next = { gated: false };
    try {
      const { data, error } = await supabase.rpc("tier_grant_payment_gate", { p_email: email });
      if (!error) next = normalizeGate(data);
    } catch {
      next = { gated: false };
    }
    if (seq !== seqRef.current) return;   // 늦게 온 옛 응답은 버린다
    gatedRef.current = next.gated;
    setGate(next);
    setLoaded(true);
  }, [email]);

  useEffect(() => { load(); }, [load]);

  // 잠긴 동안에만 경로 이동마다 다시 확인한다(결제 뒤 풀림)
  useEffect(() => {
    if (gatedRef.current) load();
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return { gate, loaded, refresh: load };
}
